import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { t } from 'i18next';
import Reset from '../../../assets/icons/Reset.svg';
import PrimaryButton from '../../../lib/ui/buttons/PrimaryButton';
import TertiaryButton from '../../../lib/ui/buttons/TertiaryButton';
import Checkbox from '../../../lib/ui/form_elements/Checkbox';
import { LABEL_COLUMNS_TRANSLATION_KEY } from '../utils';
import { colors } from '../../../theme/style-helpers';
import {
  LeftSideBarBodyContainer, TitlesContainer, Title, SubTitle,
} from './css';
import { BoxContainer, BoxInfo } from '../css';

const BOX_CONTAINER_MAX_WIDTH = '347px';
const BOX_CONTAINER_MAX_HEIGHT = '597px';

export const CustomizeBody = ({ columns, changeColumns, tabColumns }) => (
  <LeftSideBarBodyContainer>
    <TitlesContainer>
      <Title>{t('CustomizeTitle')}</Title>
      <SubTitle>{t('CustomizeSubTitle')}</SubTitle>
    </TitlesContainer>

    <BoxContainer
      bgColor={colors.LIGHT_GREY}
      maxWidth={BOX_CONTAINER_MAX_WIDTH}
      maxHeight={BOX_CONTAINER_MAX_HEIGHT}
    >
      <BoxInfo>
        <Checkbox
          input={{
            value: columns,
            onChange: changeColumns,
          }}
          options={tabColumns.filter((column) => (column !== 'actions')).map((column) => ({
            label: t(`Column${LABEL_COLUMNS_TRANSLATION_KEY[column]}`),
            value: column,
            disabled: (column === 'actions' || column === 'shipmentNumber'),
          }))}
          multiple
        />
      </BoxInfo>
    </BoxContainer>

    <Field
      name="rememberSelection"
      label={t('CustomizeRememberSelection')}
      component={Checkbox}
    />
  </LeftSideBarBodyContainer>
);

export const CustomizeFooter = ({ clearColumns, applySelection }) => (
  <>
    <TertiaryButton
      label={t('Clear')}
      onClick={clearColumns}
      showArrow={false}
      iconSrc={Reset}
      isIconLeftPosition
    />
    <PrimaryButton
      label={t('ApplySelection')}
      onClick={applySelection}
    />
  </>
);

CustomizeBody.propTypes = {
  columns: PropTypes.array,
  changeColumns: PropTypes.func,
  tabColumns: PropTypes.array,
};

CustomizeFooter.propTypes = {
  clearColumns: PropTypes.func,
  applySelection: PropTypes.func,
};
